import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import CheckIcon from '@hapana/shared/web/styles/assets/svgs/check.svg'
import AlertDialog from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.component'
import {
  SIZES,
  VARIANTS,
} from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

export const AssignEquipmentQueueSuccessAlert = ({ clientName }) => {
  const { t } = useTranslation('checkIn')
  const { popDialog, popToDialog } = useDialog()

  return (
    <AlertDialog
      title={t('checkIn:equipments.alerts.assignToEquipment.successTitle', { name: clientName })}
      description={t('checkIn:equipments.alerts.assignToEquipment.successWaitlineDescription')}
      icon={CheckIcon}
      size={SIZES.XS}
      variant={VARIANTS.SUCCESS}
      closeAction={popDialog}
      primaryAction={{
        label: t('checkIn:okay'),
        action: () => {
          popToDialog((_, i) => i === 0, { defaultTab: '1' })
        },
      }}
    />
  )
}

AssignEquipmentQueueSuccessAlert.propTypes = {
  clientName: PropTypes.string.isRequired,
  isTestMode: PropTypes.bool,
}

export default AssignEquipmentQueueSuccessAlert
